import { Menu, MenuItem, Box, useTheme } from "@mui/material";
import { useAppStore } from "../../../stores/appStore";
import {
  menuComponentStyles,
  copyLinkMenuItemStyles,
  menuItemStyles,
} from "../../chat/message-menu-dropdown/styles";
import type { MessageMenuItem } from "../../../types";
import { MessageMenuVisualisation } from "../../chat/message-menu-dropdown/message-menu-visualisation";
import { ReactionBlock } from "../../../components/chat/message-menu-dropdown/reaction-block/reaction-block";

type StaticMessageMenuDropdownProps = {
  handleReactionClick?: (reactionKey: string) => void;
  handleCopyLink?: () => void;
  handleCopyMessageText?: () => void;
  handleAddToFavorite?: () => void;
  handleReportMessage?: () => void;
  menuItems?: MessageMenuItem[];
  handleSendMenuItem?: (
    text: string,
    description: string,
    chosen_text?: string,
  ) => void;
  text?: string;
  selectedText?: string;
  isOpen?: boolean;
  anchorPosition: { top: number; left: number };
};

export const StaticMessageMenuDropdown = ({
  handleReactionClick = () => {},
  handleCopyLink = () => {},
  handleCopyMessageText = () => {},
  handleAddToFavorite = () => {},
  handleReportMessage = () => {},
  handleSendMenuItem = () => {},
  menuItems = [],
  text,
  selectedText,
  isOpen = true,
  anchorPosition,
}: StaticMessageMenuDropdownProps) => {
  const theme = useTheme();
  const { markedIds } = useAppStore();

  return (
    <Menu
      open={isOpen}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      sx={{
        ...menuComponentStyles,
        pointerEvents: "none",
        "& .MuiMenuItem-root": {
          backgroundColor: theme.palette.messageMenuDropdown.bg,
          borderTop: `1px solid ${theme.palette.messageMenuDropdown.border}`,
        },
        "& .MuiMenuItem-root:first-of-type": {
          backgroundColor: theme.palette.messageMenuDropdown.bg,
          borderTop: "none",
        },
        "& .MuiMenuItem-root:only-of-type": {
          backgroundColor: theme.palette.messageMenuDropdown.bg,
          borderTop: "none",
        },
        "& .MuiMenuItem-root:last-of-type": {
          backgroundColor: theme.palette.messageMenuDropdown.bg,
          borderBottomRightRadius: "18px",
          borderBottomLeftRadius: "18px",
        },
        ...(!text && {
          "& .MuiMenuItem-root:first-of-type": {
            backgroundColor: theme.palette.messageMenuDropdown.bg,
            borderTopLeftRadius: "18px",
            borderTopRightRadius: "18px",
          },
        }),
      }}
      onClose={() => {}}
      classes={{ paper: "custom-menu-paper" }}
    >
      {!selectedText && (
        <Box>
          <ReactionBlock
            markedIds={markedIds}
            handleReactionClick={handleReactionClick}
            handleAddToFavorite={handleAddToFavorite}
            handleReportMessage={handleReportMessage}
          />
        </Box>
      )}
      {text && (
        <MenuItem
          sx={copyLinkMenuItemStyles}
          onClick={handleCopyMessageText}
          disableRipple
        >
          {selectedText ? "📋 Copy Selected Text" : "📋 Copy Message Text"}
        </MenuItem>
      )}
      <MessageMenuVisualisation
        items={menuItems}
        selectedText={selectedText}
        text={text}
        handleSendMenuItem={handleSendMenuItem}
      />
      {!selectedText && (
        <MenuItem sx={menuItemStyles} onClick={handleCopyLink} disableRipple>
          🔗 Copy Message Link
        </MenuItem>
      )}
      <MenuItem
        sx={menuItemStyles}
        onClick={() => {}}
        disableRipple
        onMouseDown={(e) => e.stopPropagation()}
      >
        🔖 Add New Tag
      </MenuItem>
    </Menu>
  );
};

export default StaticMessageMenuDropdown;
